'use client';

import { Icon } from '@backyard-ui/core';
import { PlayCircle } from '@backyard-ui/icons';

import type { MediaItem } from '../Medias';

import styles from './Thumb.styles';

interface ThumbProps extends Pick<MediaItem, 'type'> {
  size?: 'sm' | 'md';
  alt: string;
  src: string;
  onClick: () => void;
}

function Thumb(props: ThumbProps) {
  const { size = 'md', type, alt, src, onClick } = props;

  return (
    <div
      className={styles({ size }).base()}
      onClick={onClick}
      role="button"
      aria-hidden="true"
      data-testid="thumb"
    >
      <picture>
        <img alt={alt} src={src} />
      </picture>

      {type === 'video' && (
        <Icon
          size="2xl"
          color="white"
          data-testid="play-icon"
          alignmentBaseline="auto"
          UNSAFE_className={styles().playIcon()}
        >
          <PlayCircle />
        </Icon>
      )}
    </div>
  );
}

export default Thumb;
